import { render } from "./Confirmation.vue?vue&type=template&id=980349f4"
import script from "./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue?vue&type=script&lang=js"
script.render = render

export default script